import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'libero-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
  standalone: false
})
export class DisclaimerComponent implements OnInit {
  public displayDisclaimer = false;

  public constructor(
    public userService: UserService,
  ) { }

  public ngOnInit(): void {
    this.displayDisclaimer = !!this.userService.loggedUser?.hasOpenOrder;
  }

  public closeDisclaimer(): void {
    this.displayDisclaimer = false;
  }
}
